import  { Component } from 'react';
import Swal from 'sweetalert2';


class Util extends Component
{
    static myInstance = null;
    static disposableDomains = ['mailinator.com', '10minutemail.com'];

    static userInfo =
    {
      userId:""
    }



    static serverName="https://myaiweb.ca";


    constructor()
    {
        
        super();
    }

  
    static getInstance()
    {
      if (Util.myInstance == null) 
      {
        Util.myInstance = new Util();
      }
      return this.myInstance;
    }

    async checkPrefix(prefix)
    {
      if(prefix=="")
      {
        return true;
      }
      
      let nPrefix = prefix.trim().toLowerCase();

      if(nPrefix.length > 20)
      {        
        return false;
      }
  
      if(!this.isAlphanumeric(nPrefix))
      {        
        return false;
      }

      return true;  
    }
    
    isAlphanumeric(input) {
      // Regular expression to match only alphanumeric characters
      const regex = /^[a-zA-Z0-9_]*$/;
    
      // Test the input string against the regex
      return regex.test(input);
    }
    
    isStrongPassword(pass) {
      // Regular expression for a strong password
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    
      // Test the password against the regex
      return regex.test(pass);
    }
    
    // Example usage:
    /*
    console.log(isStrongPassword("Password123!")); // true
    console.log(isStrongPassword("WeakPass")); // false (too short, no special character, no number)
    console.log(isStrongPassword("password123")); // false (no uppercase letter, no special character)
    console.log(isStrongPassword("PASSWORD!")); // false (no lowercase letter, no number)
    console.log(isStrongPassword("Pass123!")); // false (too short)
    */
    
    isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      return regex.test(email);
    }
    
    normalizeEmail(email) {
      return email.trim().toLowerCase();
    }
        
    
    isDisposableEmail(email) {
      const domain = email.split('@')[1];
      return Util.disposableDomains.includes(domain);
    }
    
    validateEmail(email) {
      const normalizedEmail = email.trim().toLowerCase();
    
      if (!this.isValidEmail(normalizedEmail)) {
        return { valid: false, message: 'Invalid email format.' };
      }
    
      if (this.isDisposableEmail(normalizedEmail)) {
        return { valid: false, message: 'Disposable email addresses are not allowed.' };
      }
    
      return { valid: true, message: 'Email is valid.' };
    }

    isHtmlFile(filename)
    {
      let l = filename.toLowerCase();

      if(l.endsWith('html'))
      {
        return true;
      }
      return false;
    }

    isAitFile(filename)
    {
      let l = filename.toLowerCase();

      if(l.endsWith('ait'))
      {
        return true;
      }
      return false;
    }

    
    getImageTypeFromFilename(filename) {
      const regex = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
      const match = filename.match(regex);
      
      if (match) {
        // Extract the file extension (e.g., '.jpg')
        const extension = match[0].toLowerCase();
    
        switch (extension) {
          case '.jpg':
          case '.jpeg':
            return 'JPEG';
          case '.png':
            return 'PNG';
          case '.gif':
            return 'GIF';
          case '.bmp':
            return 'BMP';
          case '.webp':
            return 'WEBP';
          case '.svg':
            return 'SVG';
          default:
            return 'Unknown';
        }
      } else {
        return 'Unknown';
      }
    }
       
    setCookie(name, value, days)
    {
        var expires="";
        if (days)
        {
            var date = new Date();
            date.setTime(date.getTime()+days*24*60*60*1000); // ) removed
            expires = "; expires=" + date.toGMTString(); // + added
        }
        else
            expires = "";

        document.cookie = name+"=" + value+expires + ";path=/"; // + and " added
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }    

    clearAllCookies()
    {
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }

        let name = c.split('=');

        let u = Util.getInstance();
        console.log(name[0])
        u.setCookie(name[0],"",0);
       
      }
    }


    beforeDecimal(num) 
    {
      if (Number.isInteger(num)) 
      {
        return 1;
      }
    
      return num.toString().split('.')[0].length;
    }



    sanitize(text) {
      let chars = [];
      let length = text.length;
      let inCodeBlock = false;
      let inMathBlock = false;
      let inLatexEnv = false;
      let latexEnvStack = [];
    
      for (let i = 0; i < length; i++) {
        // Triple backtick code block
        
        if (text.startsWith('```', i)) {
          inCodeBlock = !inCodeBlock;
          chars.push('```');
          i += 2;
          continue;
        }
    
        // $$ math block
        if (!inCodeBlock && text.startsWith('$$', i)) {
          inMathBlock = !inMathBlock;
          chars.push('$$');
          i += 1;
          continue;
        }
    
        // LaTeX environment
        /*
        if (!inCodeBlock && !inMathBlock && text.startsWith('\\\\begin{', i)) {
          const endIdx = text.indexOf('}', i + 7);
          if (endIdx !== -1) {
            const envName = text.slice(i + 7, endIdx);
            latexEnvStack.push(envName);
            inLatexEnv = true;
          }
        }
    
        if (!inCodeBlock && inLatexEnv && text.startsWith('\\\\end{', i)) {
          const endIdx = text.indexOf('}', i + 5);
          if (endIdx !== -1) {
            const envName = text.slice(i + 5, endIdx);
            if (latexEnvStack[latexEnvStack.length - 1] === envName) {
              latexEnvStack.pop();
              if (latexEnvStack.length === 0) {
                inLatexEnv = false;
              }
            }
          }
        }
        */
    
        // Skip sanitization inside code/math blocks
        if (inCodeBlock || inMathBlock || inLatexEnv) {
          chars.push(text[i]);
          continue;
        }
    
        // Inline math detection: $...$
        if (text[i] === '$') {
          const end = this.findInlineMathEnd(i, text);
          if (end !== -1) {
            // Valid inline math block — include as-is
            for (let j = i; j <= end; j++) {
              chars.push(text[j]);
            }
            i = end; // skip over processed block
            continue;
          } else {
            // Not part of inline math — escape
            // chars.push('\\$');
            chars.push('\\$');
            continue;
          }
        }
    
        chars.push(text[i]);
      }
    
      return chars.join('');
    }
    

    findInlineMathEnd(i, text) {
      // Must not be at end
      let next = text[i+1];
      if (i + 1 >= text.length || /\s/.test(next) ||  
            (this.isPunctuation(next) && next !== '\\') /*|| 
            this.isUnicodePunctuation((next) && next !== '\\')*/ ) return -1;
    
      for (let j = i + 1; j < text.length; j++) {
        if (text[j] === '\n') return -1;
        if (text[j] === '$') {
          // Check prev character isn't whitespace
          let prev = text[j-1];
          if (!/\s/.test(prev) &&
              (!this.isPunctuation(prev) || prev === '\\') /*&& 
              (!this.isUnicodePunctuation(prev) || prev === '\\')*/) {
            return j;
          } else {
            return -1;
          }
        }
      }
    
      return -1; // no closing found
    }
    
    
    isPunctuation(char) {
      return /[.,:;!?'"`~@#%^&*<>/|_-]/.test(char);
    }
    
    isUnicodePunctuation(char) {
      if (!char) return false;
      return /\p{P}/u.test(char);
    }
    
}

export default Util;